import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

import Utils from '../services/utils.service'

export default class HomeService {
	constructor() {
		this.sectionHighlightSlider().then()
		this.sectionAreasSlider().then()
		this.sectionTagsSlider().then()
		this.sectionSpiritSlider().then()
		this.sectionWalkSlider().then()
		this.preloader()
		Utils.toggleIsActiveClass('[data-js="curtain-link"]', 'mouseover')
		Utils.toggleIsActiveClass('[data-js="strate-walks-item"]', 'mouseover')
	}

	async sectionHighlightSlider() {
		const options = {
			spaceBetween: 10,
			slidesPerView: 1,
		}

		Utils.swiperWrapper('[data-slider="strate-higlight"]', 'div')
		await Swiper.create('[data-slider="strate-higlight"]', options)
	}

	async sectionAreasSlider() {
		const selector = '[data-slider="strate-areas"]'
		const options = {
			slidesPerView: 1,
			centeredSlides: true,
			effect: 'coverflow',
			coverflowEffect: {
				rotate: 75,
				stretch: 0,
				depth: 100,
				modifier: 1,
				slideShadows: false,
			},
			speed: 1000,

			spaceBetween: 10,
			parallax: true,
			grabCursor: true,
			initialSlide: 1,

			// Custom pagination
			pagination: {
				el: '.strate__areas__slider-navigation',
				clickable: true,
				renderBullet: (index, className) => `<div class="${className}">0${index + 1}</div>`,
			},
			on: {
				init: (swiper) => {
					$(`[data-area-id="${swiper.activeIndex}"]`).addClass('is-active')
				},
				transitionStart: () => {
					const $activeSlideIndex = $(
						'.strate__areas__items__titles__slider__item.swiper-slide-active',
					).data('area-item')
					$('.strate__areas__items__elements__item').removeClass('is-active')
					$(`[data-area-id="${$activeSlideIndex}"]`).addClass('is-active')
				},
			},
			breakpoints: {
				650: {
					spaceBetween: 40,
				},
			},
		}

		Utils.swiperWrapper(selector, 'div')

		await Swiper.create(selector, options)
	}

	async sectionTagsSlider() {
		const selector = '[data-slider="strate-tags"]'
		let swiper
		const options = {
			effect: 'creative',
			creativeEffect: {
				prev: {
					translate: ['-40%', 0, -1],
				},
				next: {
					translate: ['100%', 0, 0],
				},
			},
			speed: 1000,
			lazy: {
				loadPrevNext: true,
			},
			on: {
				slideChange: (swiper) => {
					const $tagItems = $('[data-id-title]')
					$tagItems.each((index, $tagItem) => {
						if (swiper.activeIndex === $($tagItem).data('id-title')) {
							const idTitle = $($tagItem).data('id-title')
							$tagItems.removeClass('is-active')
							$(`[data-id-title="${idTitle}"]`).addClass('is-active')
						}
					})
				},
			},
		}

		Utils.swiperWrapper(selector, 'div')
		swiper = await Swiper.create(selector, options)

		const $tagItems = $('[data-id-title]')
		$tagItems.on('mouseover', function () {
			swiper.slideTo($(this).data('id-title'), 1000)
		})

		if (window.matchMedia('(max-width:650px)').matches) {
			swiper.destroy(true, true)
			options.effect = 'slide'
			options.allowTouchMove = true
			options.spaceBetween = 10
			swiper = await Swiper.create(selector, options)
		}
	}

	async sectionSpiritSlider() {
		const selector = '[data-slider="strate-spirit"]'

		const options = {
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 5000,
			},
			speed: 400,
			parallax: true,
			pagination: {
				el: '.strate__spirit__slider-navigation',
				clickable: true,
				renderBullet: (index, className) => `<div class="${className}">0${index + 1}</div>`,
			},
			breakpoints: {
				650: {
					speed: 1000,
				},
			},
		}

		Utils.swiperWrapper(selector, 'div')

		await Swiper.create(selector, options)
	}

	async sectionWalkSlider() {
		const selector = '[data-slider="strate-walks"]'

		const options = {
			slidesPerView: 1,
			spaceBetween: 10,
			breakpoints: {
				650: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		}

		if (window.matchMedia('(max-width: 1000px)').matches) {
			Utils.swiperWrapper(selector, 'div')
			await Swiper.create(selector, options)
		}
	}

	preloader() {
		const $body = $('body')
		if (!$body.hasClass('eco-mode-active')) {
			setTimeout(() => {
				this.closePreloader()
			}, 2000)
			$('.header__preloader .header__preloader__close').on('click', () => {
				this.closePreloader()
			})
			if ($('.header__preloader').is(':visible')) {
				$(document).keydown((e) => {
					const keycode = e.keyCode || e.which
					if (keycode === '27') {
						this.closePreloader()
					}
				})
			}
		}
	}

	closePreloader() {
		const videoPlayer = $('video.header__banner__item__video')
		const $body = $('body')

		if (videoPlayer.length) {
			videoPlayer.get(0).currentTime = 0
			videoPlayer.get(0).play()
		}
		$('.header__preloader').fadeOut()
	}
}
